export default class Core6Config {
  static getAjaxConfig() {
    return {
      headers: {
        'content-type': 'multipart/form-data',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        Authorization: `Bearer ${document.getElementById('API_TOKEN').value}`,
        responseType: 'text',
      },
    };
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6Config.js